<!-- 合伙人入驻合作模式选择 -->
<style lang="scss" scoped>
.cooperation-mode-dialog-wrapper {
  .content {
    background: #ffffff;
    padding: 20px;

    .title {
      text-align: center;
      font-size: 28px;
      font-weight: 500;
    }

    .card {
      display: flex;
      gap: 20px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;
        border: 1px solid #dcdcdc;
        background: #ffffff;
        flex: 1;
        cursor: pointer;

        img {
          width: 112px;
          margin-bottom: 24px;
        }

        &:hover {
          cursor: pointer;
          border: 1px solid #002fbe;
          background: linear-gradient(180deg, rgba(0, 47, 190, 0) 71%, rgba(0, 47, 190, 0.29) 100%);

          .btn-checked {
            background: #002fbe;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.cooperation-mode-dialog-wrapper {
  padding: 0 !important;

  .el-dialog__header {
    padding: 16px;
    .el-dialog__title {
      font-size: 18px;
      font-weight: 500;
    }
  }

  .el-dialog__body {
    background: #f2f2f2;
    padding: 20px;
  }

  .el-dialog__headerbtn {
    font-size: 18px;
    height: 58px;
  }
}
</style>

<template>
  <el-dialog v-model="visible" class="cooperation-mode-dialog-wrapper" title="合伙人入驻" width="1020px" append-to-body :close-on-click-modal="false">
    <div class="content">
      <div class="title pb-20px">请选择合作模式</div>
      <div class="card">
        <div class="item">
          <img :src="enterprisePartner" />
          <div class="mb-8px text-24px font-medium">
            {{ JOIN_TYPE_ENUM.CITY_PARTNER.label }}
          </div>
          <div class="mb-24px text-16px text-#999999">适合市场资源较多的企业或个人</div>
          <div
            class="btn-checked cursor-pointer border border-#002FBE border-solid px-24px py-8px text-16px text-#002FBE"
            @click="partnerJoinProcess(JOIN_TYPE_ENUM.CITY_PARTNER.value)"
          >
            立即入驻
          </div>
        </div>
        <div class="item">
          <img :src="personalPartner" />
          <div class="mb-8px text-24px font-medium">
            {{ JOIN_TYPE_ENUM.AMBASSADOR.label }}
          </div>
          <div class="mb-24px text-16px text-#999999">适合兼职类型推广合作</div>
          <div
            class="btn-checked cursor-pointer border border-#002FBE border-solid px-24px py-8px text-16px text-#002FBE"
            @click="partnerJoinProcess(JOIN_TYPE_ENUM.AMBASSADOR.value)"
          >
            立即入驻
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { JOIN_TYPE_ENUM } from '@/constants/common'
import event from '@/event/index'
import { OPEN_JOIN_CORP_DIALOG } from '@/event/modules/site'
import enterprisePartner from '@/assets/image/p-partner.png'
import personalPartner from '@/assets/image/p-personal.png'

const visible = ref(false)

const open = () => {
  visible.value = true
}

const close = () => {
  visible.value = false
}

const partnerJoinProcess = (joinType) => {
  event.emit(OPEN_JOIN_CORP_DIALOG, { joinType })
  close()
}

defineExpose({
  open,
  close,
})
</script>
